"use strict";

($dt => {
	// Localized Constants
	//const { TOPIC_TYPES, DEBOUNCE_DEFAULT } = $dt.TopicGrid.Constants; 

	// Localized Functions
	const { get_topic_type_variant, toggle_variant_visibility } = $dt.TopicGrid.Functions;

	/**
	 * Global setups
	 * @param {Block} block 
	 * @param {InnerScreen} inner_screen 
	 * @param {*} controller 
	 */
	const setup_screen = (block, inner_screen, controller) => {
		const { inner_elem } = inner_screen;
		const [ button_prev_elem, button_next_elem ] = [
			inner_elem.querySelector('.button-prev'),
			inner_elem.querySelector('.button-next'),
		];

		inner_screen.ScreenIsValid = () => {
			const { scheduling_info } = block;
			if (scheduling_info.selected_date) {
				// Need a double check on date here since other controls on the page can interfere
				button_next_elem.removeAttribute('disabled');
			}
		};

		inner_screen.ScreenIsInvalid = () => {
			button_next_elem.setAttribute('disabled', '');
		};

		inner_screen.RefreshAjax = (skip_availability) => {
			controller.UpdateCalendar(block, skip_availability, skip_availability);
		};

		// Back to topic details
		button_prev_elem.addEventListener('click', () => {
			const { current_screen } = block;
			current_screen.inner = 0;
			controller.ClearSelectedDate(block);
			controller.SetScreenUI(block);
		});

		// Next button on date selected
		button_next_elem.addEventListener('click', () => {
			const { current_screen, scheduling_info } = block;
			controller.StartWaiting(block);
			controller.GetDateTimes(block, resp => {
				controller.EndWaiting(block);
				scheduling_info.available_times = resp.times;
				current_screen.inner = 4;
				controller.SetScreenUI(block);
			});
		});

		// Setup date clicks
		block.calendar_date_clicked_events.push(() => {
			const { scheduling_info } = block;
			if (scheduling_info.selected_date) {
				inner_screen.ScreenIsValid();
			} else {
				inner_screen.ScreenIsInvalid();
			}
		});
	};

	/**
	 * This screen is for setting calendar date. Num attendees can be changed.
	 * 
	 * @param {Block} block 
	 * @param {InnerScreen} inner_screen 
	 * @param {*} controller 
	 */
	$dt.TopicGrid.ScreenFunctions.o0_i3 = (block, inner_screen, controller) => {
		// Number of attendees, on change event for attendees should update highlighted calendar dates, initial update with current num attendees on load
		const { inner_elem } = inner_screen;

		// Screen Setup
		setup_screen(block, inner_screen, controller);

		// Inner contents organized by the topic type
		const topic_type_variants = [
			$dt.TopicGrid.SelectAttendees.createOnsiteVariant(inner_elem.querySelector('.onsite-attendees'), block, inner_screen),
			$dt.TopicGrid.SelectAttendees.createOnsiteSelfGuidedVariant(inner_elem.querySelector('.onsite-self-guided-attendees'), block, inner_screen),
			$dt.TopicGrid.SelectAttendees.createStgVariant(inner_elem.querySelector('.stg-attendees'), block, inner_screen),
			$dt.TopicGrid.SelectAttendees.createCommunityVariant(inner_elem.querySelector('.reservation-attendees'), block, inner_screen),
		];

		// On showing this screen
		inner_screen.Show = () => {
			const { current_topic } = block;

			// Reset the previous selected date
			controller.ClearSelectedDate(block);

			// Disable button
			inner_screen.ScreenIsInvalid();

			// Select current variant based on the topic type selected
			const current_variant = get_topic_type_variant(current_topic.topic_type, topic_type_variants);
			toggle_variant_visibility(current_variant, topic_type_variants);

			// Run variant show
			current_variant.show();
		};

		// Run Variant Setups
		topic_type_variants.forEach(variant_setup => {
			variant_setup.setup();
		});
	};

})(window.d3_wp_themejs);
